import { LogLevel, LogMethod, Logger, LoggerStrategy } from "./logger.types"

// Default strategy for development and CI
// Calls console.* without dispatching to any external service
const ConsoleLoggerStrategy: LoggerStrategy = {
  log(level, message, context, error) {
    // eslint-disable-next-line no-console
    console[level](message, context, error)
  },
}

let strategy: LoggerStrategy = ConsoleLoggerStrategy

// Must be initialized at app entrypoints using
// platform specific `LoggerStrategy` implementations.
export function setLoggerStrategy(s: LoggerStrategy) {
  strategy = s
}

// Logger factory with optional scope
function createLogger(scope?: string): Logger {
  // Injects scope and delegates to strategy
  const scopedLog: Logger["log"] = (level, msg, ctx, error) => {
    const context = scope ? { ...ctx, scope } : ctx ?? {}
    strategy.log(level, msg, context, error)
  }

  const mkLevel =
    (level: LogLevel): LogMethod =>
    (msg, ctx, error) =>
      scopedLog(level, msg, ctx, error)

  return {
    log: scopedLog,
    dbug: mkLevel("debug"),
    info: mkLevel("info"),
    warn: mkLevel("warn"),
    error: mkLevel("error"),
    withScope: (next) => createLogger(scope ? `${scope}.${next}` : next),
  }
}

export const logger: Logger = createLogger()
